import React from "react";
import "./GreenSteelAwardee.css";
import { Link } from "react-router-dom";

const GreenSteelAwardee = () => {
  const events = [
    {
      title: "Bhagwati Steel Cast Private Limited",
      company:"(Nashik, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/bhagwati.JPG",
      link: "/aaiifa-event-2024",
    },
    {
      title: "Bhagyalaxmi Rolling Mills",
      company:"(Jalna, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/bhagyalaxmi.JPG",
      link: "/aaiifa-event-2023",
    },
    {
      title: "Devashree Ispat Limited",
      company:"(Jalna, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/devashree.JPG",
      link: "/past-event-2022",
    },
    {
      title: "Guardian Castings Private Limited",
      company:"(Palghar Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/guardian.JPG",
      link: "/past-event-2019",
    },
    {
      title: "Kalika Steel Alloys Pvt. Ltd.",
      company:"(Jalna, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/kalika.JPG",
      link: "/past-event-2018",
    },
    {
      title: "Mono Steel (India) Limited",
      company:"(Kutch, Gujrat)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/mono-steel.JPG",
      link: "/past-event-2017",
    },
    {
      title: "Rathi Steel and Metal Private Limited",
      company:"(Jalna, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/rathi-steel.JPG",
      link: "/past-event-2016",
    },
    {
      title: "SRJ Peety Steels Private Limited (Jalna, Maharashtra)",
      company:"(Jalna, Maharashtra)",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/green-steel-awards/srg-peeti.JPG",
      link: "/past-event-2016",
    },
  ];

  return (
    <>
      
      <section className="past-events-section">
        <div className="past-events-container">
          <div className="past-events-header">
            <p className="past-events-subtitle">Green Steel Awardee</p>
            <h1 className="past-events-main-title">AIIFA</h1>
          </div>

          <div className="past-events-grid">
  {events.map((event, index) => (
    <Link
      to={event.link}
      className="past-event-card"
      key={index}
    >
      <div className="past-event-image">
        <img src={event.img} alt={event.title} />
      </div>
      <div className="past-event-title-bar">
        <h3>{event.title}</h3>
        <h3>{event.company}</h3>
      </div>
    </Link>
  ))}
</div>
        </div>
      </section>
    </>
  );
};

export default GreenSteelAwardee;
